module.exports = __webpack_public_path__ + "static/media/locate-charging-stations-no-hover.75eb5973.svg";